
import {filter} from 'rxjs/operators';
import { MatDialog } from '@angular/material/dialog';
import { CompleteDataGeneralComponent } from './../../admin/users/complete-data-general/complete-data-general.component';
import { Component, OnInit, OnDestroy, ViewChild, HostListener } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { MenuItems } from '../../shared/menu-items/menu-items';
import { Subscription } from 'rxjs';

import { GeneralService } from '../../services/general.service';
import {LoginService} from '../../services/login.service';
import { TranslateService } from 'ng2-translate/ng2-translate';
import PerfectScrollbar from 'perfect-scrollbar';
import { PerfectScrollbarConfigInterface, PerfectScrollbarComponent, PerfectScrollbarDirective } from 'ngx-perfect-scrollbar';

import * as decode from 'jwt-decode';

@Component({
  selector: 'app-layout',
  templateUrl: './admin-layout.component.html'
})
export class AdminLayoutComponent implements OnInit, OnDestroy {
  txtHeader = 'Bienvenido';
  showFolderNotice = 'false';
  showFolderAdmin = 'false';
  private _router: Subscription;

  today: number = Date.now();
  url: string;
  showSettings = false;
  dark: boolean;
  boxed: boolean;
  collapseSidebar: boolean;
  compactSidebar: boolean;
  sidebarBg: boolean = true;
  currentLang = 'es';
  welcome = 'WELCOME';
  layoutDir = 'ltr';

  selectedSidebarImage : any = 'bg-1';
  selectedSidebarColor : any = 'sidebar-click';
  selectedHeaderColor  : any = 'header-default';
  collapsedClass       : any = 'side-panel-opened';

  firstSession:string;
  tokenCrypt ;
  userToken;
  tokenInfo;

  @ViewChild('sidemenu', { static: true }) sidemenu;
  public config: PerfectScrollbarConfigInterface = {};

  userData: any = {};
  menus: any;
  language='es';


  constructor(private router: Router, public menuItems: MenuItems, public translate: TranslateService, private gralService: GeneralService, private authService: LoginService, private dialog: MatDialog ) {
    const browserLang: string = translate.getBrowserLang();
    translate.use(browserLang.match(/en|fr|es/) ? browserLang : 'es');
    this.userData = decode(localStorage.getItem('G13xTfsdf234TVsd23513ffdgFdf2352'));

    this.userToken =  localStorage.getItem('G13xTfsdf234TVsd23513ffdgFdf2352');
    //localStorage.setItem('firstSession', 'yes');
    const d = this.userToken.split('Bearer ');
    this.tokenInfo = this.userData;
    this.firstSession = localStorage.getItem('firstSession');

    const idioma = localStorage.getItem('language');


    this.txtHeader = (idioma=='es') ? 'Bienvenido':'Welcome';

    this.language = idioma;
    translate.use(idioma);

    this.tokenCrypt = d[1];

    gralService.myBool$.subscribe((newHead: string) => {
      this.txtHeader = newHead;
    });

    gralService.myNotice$.subscribe((newHead: any) => {
      this.showFolderNotice = newHead;
    });

    gralService.gral$.subscribe((newHead: any) => {
      this.showFolderAdmin = newHead;
    });

    gralService.tokenActive.subscribe((newBool: boolean) => {
      if(!newBool){
        this.logout();
      }
    });

    this.getMenus();

  }

  translateLang(lang){
  this.language = lang;
    let tempLang = localStorage.setItem('language', lang);
  }

  ngOnInit(): void {
    const elemSidebar = <HTMLElement>document.querySelector('.sidebar-container ');
    // const elemSidebar = <HTMLElement>document.querySelector('.app-inner > .sidebar-panel');
    // const elemContent = <HTMLElement>document.querySelector('.app-inner > .mat-sidenav-content');

    if (window.matchMedia(`(min-width: 960px)`).matches && !this.isMac() && !this.compactSidebar) {
      // Ps.initialize(elemSidebar, { wheelSpeed: 2, suppressScrollX: true });
      // Ps.initialize(elemContent, { wheelSpeed: 2, suppressScrollX: true });
      const ps = new PerfectScrollbar(elemSidebar, {
                              wheelSpeed: 2,
                              suppressScrollX: true
                            });
    }

    this._router = this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
      this.url = event.url;
      if (this.isOver()) {
        this.sidemenu.close();
      }

      if (window.matchMedia(`(min-width: 960px)`).matches && !this.isMac() && !this.compactSidebar) {
        // Ps.update(elemContent);
      }
    });

    if(this.firstSession){
      console.log('entro if 1');
      if(this.firstSession == 'yes'){
        setTimeout(()=>{
          localStorage.setItem('tempRegister', this.tokenCrypt);
          this.complementInfo(this.tokenCrypt);
          return;
        }, 1000);
      }else{
        localStorage.setItem('firstSession', 'no');
        this.firstSession = 'no';
        return;
      }


    }else{
      console.log('entro else');
      if(this.firstSession == null && this.tokenInfo.ValidarDatosProveedor ){
        console.log(this.tokenInfo.ValidarDatosProveedor );
        localStorage.setItem('firstSession', 'yes');
        setTimeout(()=>{
          localStorage.setItem('tempRegister', this.tokenCrypt);
          this.complementInfo(this.tokenCrypt);
          return;
        }, 1000);
      }else{
        localStorage.setItem('firstSession', 'no');
        this.firstSession = 'no';
      }
    }
  }


  complementInfo(info){
    this.dialog.open(CompleteDataGeneralComponent, {
      disableClose:true,
      hasBackdrop: true,
      minWidth: '80%',
      // position: {
      //   top: '6%'
      // },
      data: { tempRegister: info }
    });
  }

  @HostListener('click', ['$event'])
  onClick(e: any) {
    // const elemSidebar = <HTMLElement>document.querySelector('.app-inner > .sidebar-panel');
    const elemSidebar = <HTMLElement>document.querySelector('.sidebar-container ');
    setTimeout(() => {
      if (window.matchMedia(`(min-width: 960px)`).matches && !this.isMac() && !this.compactSidebar) {
        // Ps.update(elemSidebar);
        const ps = new PerfectScrollbar(elemSidebar, {
                              wheelSpeed: 2,
                              suppressScrollX: true
                            });
      }
    }, 350);
  }

  ngOnDestroy() {
    this._router.unsubscribe();
  }

  isOver(): boolean {
    if (this.url === '/apps/messages' || this.url === '/apps/calendar' || this.url === '/apps/media' || this.url === '/maps/leaflet') {
      return true;
    } else {
      return window.matchMedia(`(max-width: 960px)`).matches;
    }
  }

  isMac(): boolean {
    let bool = false;
    if (navigator.platform.toUpperCase().indexOf('MAC') >= 0 || navigator.platform.toUpperCase().indexOf('IPAD') >= 0) {
      bool = true;
    }
    return bool;
  }

  menuMouseOver(): void {
    if (window.matchMedia(`(min-width: 960px)`).matches && this.collapseSidebar) {
      this.sidemenu.mode = 'over';
    }
  }

  menuMouseOut(): void {
    if (window.matchMedia(`(min-width: 960px)`).matches && this.collapseSidebar) {
      this.sidemenu.mode = 'side';
    }
  }

  menuToggleFunc() {
    this.sidemenu.toggle();
    if(this.collapsedClass == 'side-panel-opened') {
        this.collapsedClass = 'side-panel-closed';
    } else {
        this.collapsedClass= 'side-panel-opened';
    }
  }

  profile(){
    this.router.navigateByUrl('/mi-perfil');
  }
  manual(){
    this.router.navigateByUrl('/manuales');
  }

  logout(){
    localStorage.removeItem('G13xTfsdf234TVsd23513ffdgFdf2352');
    localStorage.clear();
    this.router.navigateByUrl('/login');
  }


  getShowModule(pattern, children){
    if(this.menus){
      if(pattern == 'HOME'){
        return true;
      }else{
        const retP = this.menus.find(x => x.Menu === pattern);
        if(retP){
          if(children){
            const retC = retP.SubMenus.find(x => x.Menu === children);
            if(retC){
              return true;
            }else{
              return false;
            }
          }else{
            return true;
          }
        }else{
          return false;
        }
      }
    }else{
      return false;
    }
  }

  getMenus(){
    const d = localStorage.getItem('G13xTfsdf234TVsd23513ffdgFdf2352').split('Bearer ');
    const tokenPayload = decode(d[1]);

    this.authService.menus(tokenPayload.Id).then((menuu) => {
      if(menuu['EsValido']){
        this.menus = menuu['Entidades'];
        for(let g = 0; g < this.menus.length; g++){
          switch (this.menus[g].Menu) {
            case 'Administrador':
              this.menus[g].Menu = 'ADMIN';
              for(let s = 0; s < this.menus[g].SubMenus.length; s++){
                switch (this.menus[g].SubMenus[s].Menu) {
                  case 'Proveedores':
                    this.menus[g].SubMenus[s].Menu = 'PROVIDERS';
                    break;
                  case 'Usuarios':
                    this.menus[g].SubMenus[s].Menu = 'USERS';
                    break;
                  case 'Empresas':
                    this.menus[g].SubMenus[s].Menu = 'COMPANIES';
                    break;
                  case 'General':
                    this.menus[g].SubMenus[s].Menu = 'GENERAL';
                    break;
                  case 'Administrar Autorizadores':
                    this.menus[g].SubMenus[s].Menu = 'ADMINAUTH';
                    break;
                  case 'Administrar Centro de costo':
                    this.menus[g].SubMenus[s].Menu = 'ADMINCC';
                    break;
                  case 'Administrar Orden interno':
                    this.menus[g].SubMenus[s].Menu = 'ADMINOI';
                    break;
                }
              }
              break;
            case 'Ordenes Cerradas':
              this.menus[g].Menu = 'ORDERSCLOSE';
              for(let s = 0; s < this.menus[g].SubMenus.length; s++){
                switch (this.menus[g].SubMenus[s].Menu) {
                  case 'Listado':
                    this.menus[g].SubMenus[s].Menu = 'LISTCLOSEORDERS';
                    break;
                  case 'Buscar':
                    this.menus[g].SubMenus[s].Menu = 'SEARCHORDERSCLOSE';
                    break;
                  case 'Aprobar':
                    this.menus[g].SubMenus[s].Menu = 'APPROVESERVICESORDERS';
                    break;
                }
              }
              break;
            case 'Ordenes Abiertas':
              this.menus[g].Menu = 'ORDERSOPEN';
              for(let s = 0; s < this.menus[g].SubMenus.length; s++){
                switch (this.menus[g].SubMenus[s].Menu) {
                  case 'Listado':
                    this.menus[g].SubMenus[s].Menu = 'LISTOPENORDERS';
                    break;
                  case 'Buscar':
                    this.menus[g].SubMenus[s].Menu = 'SEARCHORDERSOPEN';
                    break;
                }
              }
              break;
            case 'Aprobar extranjeros':
                this.menus[g].Menu = 'APPROVEORDERS';
                for(let s = 0; s < this.menus[g].SubMenus.length; s++){
                  switch (this.menus[g].SubMenus[s].Menu) {
                    case 'Aprobar Ordenes Cerradas':
                      this.menus[g].SubMenus[s].Menu = 'APPROVECLOSEORDERS';
                      break;
                    case 'Aprobar Ordenes Abiertas':
                      this.menus[g].SubMenus[s].Menu = 'APPROVEOPENORDERS';
                      break;
                  }
                }
                break;
            case 'Servicios':
              this.menus[g].Menu = 'SERVICES';
              for(let s = 0; s < this.menus[g].SubMenus.length; s++){
                switch (this.menus[g].SubMenus[s].Menu) {
                  case 'Listado':
                    this.menus[g].SubMenus[s].Menu = 'LISTSERVICES';
                    break;
                  case 'Buscar':
                    this.menus[g].SubMenus[s].Menu = 'CHARGESERVICES';
                    break;
                  case 'Administrar Retenciones':
                    this.menus[g].SubMenus[s].Menu = 'MANAGERETENTIONS';
                    break;
                  case 'Aprobar':
                    this.menus[g].SubMenus[s].Menu = 'APPROVESERVICES';
                    break;

                }
              }
              break;
            case 'Aprobar Servicios_':
              this.menus[g].Menu = 'SERVICESAPPROVE';
              break;

            case 'Consignacion':
              this.menus[g].Menu = 'CONSIGNMENT';
              console.log('entro a lista');
              for(let s = 0; s < this.menus[g].SubMenus.length; s++){
                switch (this.menus[g].SubMenus[s].Menu) {
                  case 'Buscar':
                    this.menus[g].SubMenus[s].Menu = 'UPLOADCONSIGNMENT';
                  break;
                  case 'Listado':
                    this.menus[g].SubMenus[s].Menu = 'LISTCONSIGNMENT';
                    break;
                }
              }

              break;

            case 'Pagos Manuales':
              this.menus[g].Menu = 'MANUALPAYMENTS';
              for(let s = 0; s < this.menus[g].SubMenus.length; s++){
                switch (this.menus[g].SubMenus[s].Menu) {
                  case 'Listado':
                    this.menus[g].SubMenus[s].Menu = 'LISTMANUALPAYMENT';
                    break;
                  case 'Buscar':
                    this.menus[g].SubMenus[s].Menu = 'SEARCHPAYMENTMANUAL';
                    break;
                }
              }
              break;
            case 'Complemento de Pago':
              this.menus[g].Menu = 'COMPLEMENTPAYMENTS';
              for(let s = 0; s < this.menus[g].SubMenus.length; s++){
                switch (this.menus[g].SubMenus[s].Menu) {
                  case 'Carga de Complemento':
                    this.menus[g].SubMenus[s].Menu = 'CHARGECOMPLEMENTS';
                    break;
                  case 'Lista':
                    this.menus[g].SubMenus[s].Menu = 'HISTORYCOMPLEMENTS';
                    break;

                  case 'Pagos Pendientes':
                    this.menus[g].SubMenus[s].Menu = 'PAYMENTPENDINGCOMPLEMENTS';
                    break;

                  case 'Carga masiva':
                    this.menus[g].SubMenus[s].Menu = 'BULKLOAD';
                  break;
                }
              }
              break;
            case 'Notas de Crédito':
              this.menus[g].Menu = 'CREDITNOTES';
              for(let s = 0; s < this.menus[g].SubMenus.length; s++){
                switch (this.menus[g].SubMenus[s].Menu) {
                  case 'Listado':
                    this.menus[g].SubMenus[s].Menu = 'LISTNOTES';
                    break;
                  case 'Buscar':
                    this.menus[g].SubMenus[s].Menu = 'SEARCHNOTES';
                    break;
                }
              }

              break;
            case 'Reportes':
              this.menus[g].Menu = 'REPORTS';
              for(let s = 0; s < this.menus[g].SubMenus.length; s++){
                switch (this.menus[g].SubMenus[s].Menu) {
                  case 'Pagos':
                    this.menus[g].SubMenus[s].Menu = 'PAYMENTS';
                    break;
                  case 'Facturas':
                    this.menus[g].SubMenus[s].Menu = 'INVOICES';
                    break;
                  case 'Ordenes':
                    this.menus[g].SubMenus[s].Menu = 'ORDERSPURCHASE';
                    break;
                    case 'Conciliacion':
                    this.menus[g].SubMenus[s].Menu = 'CONCILIACION';
                    break;
                }
              }
              break;

            case 'Contacto':
              this.menus[g].Menu = 'CONTACT';
            break;

            case 'Comunicados':
              this.menus[g].Menu = 'NOTICE';
            break;

          }
        }
      }
    }, (err) => {
      console.log(err);
    });
  }

}




  /*{
    state: 'inicio',
    name: 'HOME',
    type: 'link',
    icon: 'home',
    role: ['super', 'admin']
  },
  {
    state: 'sistema',
    name: 'SYSTEM',
    type: 'link',
    icon: 'settings_brightness',
    role: ['all']
  },
  {
    state: 'reportes',
    name: 'REPORTS',
    type: 'sub',
    icon: 'trending_up',
    role: ['all'],
    children: [
      {state: 'facturas', name: 'INVOICES'},
      {state: 'ordenes', name: 'ORDERSPURCHASE'},
      {state: 'pagos', name: 'PAYMENTS'},
      {state: 'Conciliacion', name: 'Conciliacion'},
    ]
  },
  {
    state: 'aprobar-servicios',
    name: 'SERVICESAPPROVE',
    type: 'link',
    icon: 'check_circle_outline',
    role: ['all']
  },
  {
    state: 'facturas-pagos',
    name: 'INVOICEPAYMENTS',
    type: 'link',
    icon: 'payment',
    role: ['all']
  },
  {
    state: 'ayuda',
    name: 'HELP',
    type: 'sub',
    icon: 'help',
    role: ['all'],
    children: [
      {state: 'faqs', name: 'FAQS'},
      {state: 'manual', name: 'MANUALUSER'},
    ]
  }*/
